import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "TT",
  "Discontinued": "Nicht mehr erhältlich",
  "Spare part list": "Ersatzteilliste",
  "Download Excel": "Excel herunterladen",
  "Recent search list": "Suchliste",
  "No data": "Keine Daten für die eingegebenen Suchparameter verfügbar",
  "spare part": "Ersatzteil",
  "none": "Keine",
  "no value": "ohne Wert",
  "No results found": "keine Ergebnisse gefunden",
  "Spare parts for": "Ersatzteile für",
  "Could not load cumulated data": "Kumulierte Daten konnten nicht geladen werden",
  "commissioning part": "Inbetriebnahmeteil",
  "wear part": "Verschleissteil",
  "Search": "Suchen",
  "Tk": "TK",
  "Spare part number": "Ersatzteilnummer",
  "drawing": "Zeichnung",
  "Products for": "Passende Produkte für",
  "Available": "Verfügbar",
  "MM": "MM",
  "The entered order code is invalid": "Der eingegebene Bestellcode ist ungültig",
  "Recommended": "Empfohlenes Ersatzteil (EE)",
  "No data available for the entered search parameters": "Zu diesen Suchparameter sind keine Daten vorhanden",
  "Search spare parts": "Ersatzteilsuche",
  "Order code / product root / serial number": "Eingabe Bestellcode / Produktwurzel / Seriennummer",
  "Characteristic": "Merkmal",
  "Please enter an order code": "Bitte geben Sie einen Bestellcode ein.",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Aus Qualitäts- und Sicherheitsüberlegungen empfiehlt Endress+Hauser ausschliesslich originale Endress+Hauser Ersatzteile zu verwenden. \nDas Gerät darf nur von Fachpersonal repariert und gewartet werden. \nDabei sind die Gerätedokumentation die einschlägigen Normen die gesetzlichen Vorschriften und die Zertifikate zu beachten!",
  "Maintenance advice": "Wartungshinweis",
  "Mo.": "MH",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "In welchen Produkten kann ich ein Ersatzteil verwenden? Durch Eingabe der Ersatzteilnummer (z.B. 71002865 oder XPD0024) werden Ihnen Geräte angezeigt in denen das Ersatzteil verwendet werden kann.",
  "tool": "Tool",
  "Production numbers": "Produktionsnummern",
  "New alternative": "Neue Alternative",
  "There are no items selected. Please use the checkboxes to make your selection": "Es wurden keine Artikel ausgewählt! Bitte markieren Sie die gewünschten Artikel in der Liste",
  "Service segmentation": "Servicesegmentierung",
  "Seg": "Seg",
  "Valid": "Gültig",
  "Pos": "PN",
  "Value": "Wert",
  "service segmentation 2": "Teile die Grundkenntnisse erfordern. Erfolgreiche Teilnahme an E+H-Grundlagenschulung ist Voraussetzung.",
  "Phase out date": "Produktauslaufdatum",
  "service segmentation 1": "Teile die Grundkenntnisse erfordern.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Nach Eingabe des Bestellcode erhalten Sie alle passenden Ersatzteile. Durch die Eingabe des gesamten Bestellcodes (z.B. FTC260-AA2A1 oder PMC51-BA21JB1CGBTDJB) erhalten Sie eine gerätespezifische Ersatzteilliste. Durch die Eingabe der Produktwurzel (z.B. FTC260 oder 83F50) erhalten Sie die Liste aller Ersatzteile zum Gerät.",
  "Set filter": "Filter setzen",
  "Search date": "Suchdatum",
  "Group": "Gruppe",
  "Warning": "Warnung",
  "Description": "Beschreibung",
  "Cancel": "Abbruch",
  "service segmentation 4": "Teile für Instandsetzung im Werk. Expertenwissen ist zwingend erforderlich.",
  "service segmentation 3": "Teile die spezielle Kenntnisse erfordern. Erfolgreiche Teilnahme an E+H-Fortgeschrittenenschulungist Voraussetzung.",
  "Drawing Position Number": "Zeichnungspositionsnummer (PN)",
  "Spare parts search": "Ersatzteilsuche",
  "Confirm": "Bestätigen",
  "Ordercode too short": "Der eigegebene Bestellcode ist zu kurz",
  "Product status": "Produktstatus",
  "Open": "Offen",
  "Clear": "Löschen",
  "PDF file with assembly instructions": "PDF-Datei mit Montagehinweisen",
  "Search products": "Produktverwendungssuche",
  "Export": "Export",
  "Production date": "Herstellungsdatum",
  "Order stop": "Bestellstopp",
  "Calibration until": "Kalibrierung bis",
  "PDF file with compatibility information": "PDF-Datei mit Kompatibilitätshinweisen",
  "Add selection to cart": "Auswahl zum Warenkorb hinzufügen",
  "Mounting advices": "Montagehinweise (MH)",
  "Recommended parts only": "Nur empfohlende Ersatzteile anzeigen",
  "not applicable": "nicht zutreffend",
  "accessories": "Zubehör",
  "Cumulative spare parts list": "Kumulierte Ersatzteilliste",
  "YYYY": "JJJJ",
  "Title": "Titel",
  "Error": "Fehler",
  "Ordercode too long": "Der eigegebene Bestellcode ist zu lang",
  "Functions": "Funktionen",
  "Rec": "EE",
  "Type": "Art",
  "Spare sensor until": "Ersatzsensor bis",
  "Spare parts until": "Verfügbarkeit von Ersatzteilen",
  "Filter": "Filter",
  "Check all": "Alle markieren",
  "Order code": "Bestellcode",
  "Repair until": "Reparatur bis",
  "Tag": "Tag",
  "Ok": "Ok",
  "Category code": "Teileklasse (TK)",
  "Phase out": "Produktauslauf",
  'Compatibility advices': 'Zusätzliche Dokumente',
  'Co.': 'Zus. Dok.'
} as LocalizedDictionary;
